const choseColors = (value) => {
  if (value === 'PRESIDENCIA') {
    return 'black';
  }
  if (value === 'MOTOS A COMBUSTION' || value === 'COMBUSTION') {
    return '#ff9800';
  }
  if (value === 'MICE') {
    return '#00acc1';
  }
  if (value === 'REPUESTOS') {
    return '#4caf50';
  }
  if (value === 'CARPA') {
    return '#f44336';
  }
  return 'black';
};

export default choseColors;
